import { GlobalResponseSetVm } from "../vm"

class GlobalResponseSet extends GlobalResponseSetVm {
  // Add any methods or computed properties specific to Local GlobalResponseSet here
  options_weight: number

  constructor(data: Partial<GlobalResponseSet> = {}) {
    super(data)
    this.options_weight = data.options_weight ?? 0
  }
}

type GlobalResponseSets = Record<string, GlobalResponseSet>

export type { GlobalResponseSets }
export { GlobalResponseSet }